import { useInventorySettings } from './queries'
import { InventorySettingFeatureCode } from './type'

export const useInventoryDisplaySetting = (featureCode: InventorySettingFeatureCode) => {
  const { data } = useInventorySettings()
  const group = data?.find((g) => g.feature_code === featureCode)
  const isEnabled = (code: string, defaultValue = true) =>
    group?.settings.find((s) => s.code === code)?.is_enabled ?? defaultValue

  return {
    showLotNumber: isEnabled('show_lot_number'),
    showRemainingStock: isEnabled('show_remaining_stock'),
    // DOF-1310: enforce_stock ต้อง default ปิด (false) ไม่เหมือนอีกสองตัวที่ default เปิด
    enforceStock: isEnabled('enforce_stock', false),
  }
}
